import { styled } from '@mui/material/styles';
import { FlagImage } from 'react-international-phone';
import { MenuProps } from '@mui/material/Menu';
import { inputBaseClasses } from '@mui/material/InputBase';
import { selectClasses } from '@mui/material/Select';
import {
  MuiInputAdornment,
  MuiMenuItem,
  MuiSelect,
} from '../../../../../modules/material';
import TextInput from '../TextInput';

export const StyledTextInput = styled(TextInput)(() => {
  return {
    [`& .${inputBaseClasses.root}`]: {
      paddingLeft: '8px',
    },

    '& label': {
      left: '75px',
    },
  };
});

export const StyledInputAdornment = styled(MuiInputAdornment)(() => {
  return {
    marginRight: '2px',
    marginLeft: '-8px',
  };
});

export const StyledSelect = styled(MuiSelect)((props) => {
  const { theme, disabled } = props;

  return {
    width: 'max-content',
    '&&&': {
      backgroundColor: theme.palette.neutral[disabled ? 100 : 50],
      border: 'none',
      fieldset: {
        display: 'none',
        border: 'none',
      },
    },
    borderRadius: '4px 0 0 4px',
    [`&.${inputBaseClasses.focused}:has(div[aria-expanded="false"])`]: {
      fieldset: {
        display: 'block',
        border: 'none',
      },
    },
    [`.${selectClasses.select}`]: {
      padding: '14px 8px',
    },
    svg: {
      right: '4px',
    },
  };
});

export const StyledSelectMenuProps: Partial<MenuProps> = {
  style: {
    height: '460px',
    width: '320px',
    top: '4px',
    left: '-36px',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
};

export const StyledMenuItem = styled(MuiMenuItem)(() => {
  return {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '8px',
  };
});

export const StyledFlagImage = styled(FlagImage)(() => {
  return {
    display: 'flex',
    width: '24px',
    height: '24px',
    boxSizing: 'border-box',
    margin: '0',
  };
});
